<template>
  <div class="ProjectGrid">

    <div class="ProjectGrid-project"
      v-for="(project, index) in projects"
      ref="project"
      :id="project.hash">

      <rule v-if="index > 0" />

      <break size="2.5" />

      <h2 class="t-heading-md c-white"
        v-if="project.title"
        v-html="project.title">
      </h2>

      <break v-if="project.title && project.description"
        size="0.25" />

      <markdown class="t-text-sm"
        v-if="project.description"
        :content="project.description" />

      <div class="ProjectGrid-sections"
        v-for="(section, index) in project.sections">

        <break v-if="index === 0" />

        <h2 class="t-caps-lg c-white"
          v-if="section.title"
          v-html="section.title">
        </h2>

        <break v-if="section.title"
          size="0.5" />

        <flex-grid v-if="section.items" pad>


          <flex-grid-cell v-for="(item, index) in section.items"
            :key="index"
            :size="section.cellSize">

            <div class="ProjectGrid-thumbnail ProjectGrid-thumbnail--isSmugmug"
              v-if="item.type === 'smugmug'">

              <div class="ProjectGrid-thumbnailImage">

                <smugmug-album-thumbnail
                  :album-key="item['smugmug-album']"
                  :image="item.image"
                  :route="item.route"
                  :show-lock-icon="showLockIcons" />

              </div>

            </div>

            <div class="ProjectGrid-thumbnail ProjectGrid-thumbnail--isVimeo"
              v-if="item.type === 'vimeo'">

              <div class="ProjectGrid-thumbnailImage">

                <vimeo-thumbnail v-bind="item" />

              </div>

            </div>

            <template v-if="item.title">

              <break size="0.5" />

              <h3 class="ProjectGrid-thumbnailTitle c-white"
                :class="{
                  't-text-sm': section.cellSize === '1of4',
                  't-heading-sm': section.cellSize === '2of4' || section.cellSize === '1of2'
                }">
                {{ item.title }}
              </h3>

            </template>

            <break />

          </flex-grid-cell>

        </flex-grid>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ProjectGrid',

  props: {
    projects: {
      type: Array,
      required: true
    },
    showLockIcons: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    projects () {
      this.$nextTick(this.scrollToAnchor)
    }
  },

  methods: {
    /**
     * Check for URL hash and scroll to anchor if it exists
     */
    scrollToAnchor () {
      if (!this.$route.hash) return
      const id = this.$route.hash.slice(1)
      const $el = document.getElementById(id)

      // Offset
      // - See fixed header offset in SiteHeader
      // - Subtract 1px for the borders between projects (looks better)
      const offset = 119

      if ($el) window.scrollTo(window.scrollX, $el.offsetTop - offset)
    }
  }
}
</script>

<style>
@import 'properties';

.ProjectGrid {
  /* background: blue; */
}

/**
 * Prevent layout jump
 */
.ProjectGrid-thumbnail {
  position: relative;
}

/**
 * BG color while before ImageComponent has loaded
 */
.theme-dk .ProjectGrid-thumbnail {
  background-color: var(--c-black);
}

/**
 * Set image ratio before SmugmugAlbumThumbnail has loaded
 */
.ProjectGrid-thumbnail--isSmugmug {
  padding-top: calc(100% * 2/3);
}

/**
 * Set image ratio before VimeoThumbnail has loaded
 */
.ProjectGrid-thumbnail--isVimeo {
  padding-top: calc(100% * 9/16);
}

.ProjectGrid-thumbnailImage {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.ProjectGrid-thumbnailTitle {
  display: flex;
  align-items: center;
}

.ProjectGrid-lockIcon {
  position: relative;
  top: -1px;
  margin-right: var(--unit-025);
}

.ProjectGrid-lockIcon svg {
  fill: var(--c-grey-lt) !important;
}
</style>



// WEBPACK FOOTER //
// ProjectGrid.vue?0265c80e